export const FEATURE_FLAG_DIDACTA_VERSION = false; // types required to make lint happy
